// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import RichMediaIFrameContent from './RichMediaIFrameContent';
import RichMediaOverlay from './RichMediaOverlay';

// Styles
import './RichMediaContent.scss';

const RichMediaContent = (props) => {
    const { show, isSingleSelected } = props;
    if (!show) return null;

    return (
        <div className="RichMediaContent">
            <RichMediaIFrameContent {...props} />
            <div className="mouse-blocker" />
            <RichMediaOverlay show={!isSingleSelected} transparent />
        </div>
    );
};

RichMediaContent.propTypes = {
    show: PropTypes.bool,
    isSingleSelected: PropTypes.bool,
};

export default RichMediaContent;
